module.exports = __webpack_public_path__ + "assets/img/mecha-btn-0216b4af.png";